export default __webpack_public_path__ + "static/media/logo.043ef1e5.JPG";